import { render } from "./TaskEditorMainInfo.vue?vue&type=template&id=c28a2860&scoped=true"
import script from "./TaskEditorMainInfo.vue?vue&type=script&lang=js"
export * from "./TaskEditorMainInfo.vue?vue&type=script&lang=js"

import "./TaskEditorMainInfo.vue?vue&type=style&index=0&id=c28a2860&scoped=true&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c28a2860"]])

export default __exports__